import { createReducer, on } from '@ngrx/store';
import { Dividend } from '../../models/dividend.model';
import * as DividendsActions from './dividends.actions';
import { PaginationState } from '../../models/stock.model';

export interface DividendsState {
  dividends: Dividend[];
  selectedDividend: Dividend | null;
  loading: boolean;
  error: any;
  pagination: PaginationState;
}

export const initialState: DividendsState = {
  dividends: [],
  selectedDividend: null,
  loading: false,
  error: null,
  pagination: {
    currentPage: 1,
    pageSize: 20,
    totalItems: 0,
  },
};

export const dividendsReducer = createReducer(
  initialState,

  // Load Dividends
  on(DividendsActions.loadDividends, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(DividendsActions.loadDividendsSuccess, (state, { dividends, pagination }) => ({
    ...state,
    dividends,
    pagination,
    loading: false,
    error: null,
  })),
  on(DividendsActions.loadDividendsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Load Single Dividend
  on(DividendsActions.loadDividend, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(DividendsActions.loadDividendSuccess, (state, { dividend }) => ({
    ...state,
    selectedDividend: dividend,
    loading: false,
    error: null,
  })),
  on(DividendsActions.loadDividendFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Create Dividend
  on(DividendsActions.createDividend, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(DividendsActions.createDividendSuccess, (state, { dividend }) => ({
    ...state,
    dividends: [...state.dividends, dividend],
    loading: false,
    error: null,
  })),
  on(DividendsActions.createDividendFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Update Dividend
  on(DividendsActions.updateDividend, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(DividendsActions.updateDividendSuccess, (state, { dividend }) => ({
    ...state,
    dividends: state.dividends.map((d) => (d.id === dividend.id ? dividend : d)),
    selectedDividend: dividend,
    loading: false,
    error: null,
  })),
  on(DividendsActions.updateDividendFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Delete Dividend
  on(DividendsActions.deleteDividend, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(DividendsActions.deleteDividendSuccess, (state, { id }) => ({
    ...state,
    dividends: state.dividends.filter((d) => d.id !== id),
    loading: false,
    error: null,
  })),
  on(DividendsActions.deleteDividendFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);
